import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import Layout from '@/layout';
import Empty from '@/layout/empty';

NProgress.configure({ showSpinner: false }); // NProgress Configuration

Vue.use(Router);
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    school: false                if set true, the item will show in schoolYear(default is false)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    noLimit: false               if set true, the menu will not need authority(default is false)
  }
 */

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      meta: { title: 'Not Found', noLimit: true },
      component: () => import(/* webpackChunkName: "errors" */ '@/views/error/NotFound')
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/404',
      name: '404',
      meta: { title: 'Not Found', noLimit: true },
      component: () => import(/* webpackChunkName: "errors" */ '@/views/error/NotFound')
    },
    {
      path: '/403',
      name: 'Forbidden',
      meta: { title: 'Access Denied', hiddenInMenu: true, noLimit: true },
      component: () => import(/* webpackChunkName: "error" */ '@/views/error/Deny')
    },
    {
      path: '/500',
      name: '500',
      meta: { title: 'Server Error', noLimit: true },
      component: () => import(/* webpackChunkName: "errors" */ '@/views/error/Error')
    },
    {
      path: '/redirect',
      component: Layout,
      hidden: true,
      children: [
        {
          path: '/redirect/:path*',
          component: () => import(/* webpackChunkName: "index" */ '@/views/redirect/index')
        }
      ]
    },
    {
      path: '/login',
      name: '登录',
      meta: { title: '登录', noLimit: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login')
    },
    {
      path: '/resetPassword',
      name: '重置密码',
      meta: { title: '重置密码', noLimit: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "login" */ '@/views/ResetPassword')
    },
    {
      path: '/:user_id/classes/enrolment/:id',
      name: '报名详情',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Enrolment')
    },
    // 签到点名详情 by mickey
    {
      path: '/:user_id/classes/register/:id',
      name: '点名详情',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Register/info')
    },
    {
      path: '/:user_id/classes/lotteryResult/:id',
      name: '摇号详情',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/LotteryResult')
    },
    {
      path: '/:user_id/classes/interviewResult/:id',
      name: '面试详情',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/interview/result')
    },
    {
      path: '/:user_id/pay/quantityRefund/:id',
      name: '批量退费',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/pay/quantity/refund')
    },
    {
      path: '/:user_id/pay/quantityRefundDetail/:id',
      name: '退费详情',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "classes" */ '@/views/pay/quantity/detail')
    },
    {
      path: '/:user_id',
      component: Layout,
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "login" */ '@/views/Index'),
          name: '首页',
          exact: true,
          meta: {
            title: '首页',
            icon: 'dashboard',
            affix: true
          }
        },
        {
          path: 'classes',
          component: Empty,
          name: '班级管理',
          children: [
            {
              path: 'inf',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Inf'),
              name: 'ClassInf',
              meta: { title: '信息管理', icon: 'dashboard', school: true }
            },
            {
              path: 'create/:id',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Create'),
              name: '编辑班级',
              meta: { title: '编辑班级', icon: 'dashboard', school: true, activeMenu: '/classes/inf' }
            },
            {
              path: 'rate',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Rate'),
              name: '课酬率设置',
              meta: { title: '课酬率设置', icon: 'dashboard', school: true }
            },
            {
              path: 'status',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Status'),
              name: '审核管理',
              meta: { title: '审核管理', icon: 'dashboard', school: true }
            },
            {
              path: 'suspend_class',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/StatusManage'),
              name: '上课状态管理',
              meta: { title: '上课状态管理', icon: 'dashboard', school: true }
            },
            {
              path: 'lottery',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Lottery'),
              name: '班级摇号',
              meta: { title: '班级摇号', icon: 'dashboard', school: true }
            },
            {
              path: 'interview',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/interview'),
              name: '面试审核',
              meta: { title: '面试审核', icon: 'dashboard', school: true }
            },
            {
              path: 'substitute',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Substitute'),
              name: '代课申请',
              meta: { title: '代课申请', icon: 'dashboard' }
            },
            {
              path: 'applysubstitute',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/ApplySubstitute'),
              name: '填写代课申请',
              meta: { title: '填写代课申请', icon: 'dashboard' }
            },
            {
              path: 'replace',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Replace'),
              name: '替换老师申请',
              meta: { title: '替换老师申请', icon: 'dashboard' }
            },
            {
              path: 'student_check',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/Register'),
              name: '签到点名',
              meta: { title: '签到点名', icon: 'dashboard', school: true }
            },
            {
              path: 'electronicFence',
              component: () => import(/* webpackChunkName: "news" */ '@/views/classes/Fence'),
              name: '电子围栏',
              meta: { title: '电子围栏', icon: 'electronicFence' }
            },
            {
              path: 'teacher_repair',
              component: () => import(/* webpackChunkName: "classes" */ '@/views/classes/CheckInVerify'),
              name: '签到审核',
              meta: { title: '签到审核', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'base',
          component: Empty,
          name: '基础数据',
          children: [
            {
              path: 'structure',
              component: () => import(/* webpackChunkName: "base-1" */ '@/views/base/structure'),
              name: '组织架构',
              meta: { title: '组织架构', icon: 'dashboard' }
            },
            {
              path: 'building',
              component: () => import(/* webpackChunkName: "base-1" */ '@/views/base/building'),
              name: '教学楼管理',
              meta: { title: '教学楼管理', icon: 'dashboard' }
            },
            {
              path: 'room',
              component: () => import(/* webpackChunkName: "base-1" */ '@/views/base/room'),
              name: '教室管理',
              meta: { title: '教室管理', icon: 'dashboard', school: true }
            },
            {
              path: 'special',
              component: () => import(/* webpackChunkName: "base-1" */ '@/views/base/special'),
              name: '项目管理',
              meta: { title: '项目管理', icon: 'dashboard' }
            },
            {
              path: 'grade',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/grade'),
              name: '级别管理',
              meta: { title: '级别管理', icon: 'dashboard' }
            },
            {
              path: 'discount',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/discount'),
              name: '打折理由',
              meta: { title: '打折理由', icon: 'dashboard' }
            },
            {
              path: 'flow',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/flow'),
              name: '流程设置',
              meta: { title: '流程设置', icon: 'dashboard' }
            },
            {
              path: 'teacher',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/teacher'),
              name: '教师管理',
              meta: { title: '教师管理', icon: 'dashboard', school: true }
            },
            {
              path: 'holiday',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/holiday'),
              name: '假日管理',
              meta: { title: '假日管理', icon: 'dashboard' }
            },
            {
              path: 'refund',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/refund'),
              name: '退费管理',
              meta: { title: '退费管理', icon: 'dashboard' }
            },
            {
              path: 'term',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/term'),
              name: '学期管理',
              meta: { title: '学期管理', icon: 'dashboard' }
            },
            {
              path: 'contract',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/contract'),
              name: '合同类型',
              meta: { title: '合同类型', icon: 'dashboard' }
            },
            {
              path: 'access',
              component: () => import(/* webpackChunkName: "base-2" */ '@/views/base/access'),
              name: '门禁管理',
              meta: { title: '门禁管理', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'sys',
          component: Empty,
          name: '系统管理',
          children: [
            {
              path: 'role',
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/role'),
              name: '角色管理',
              meta: { title: '角色管理', icon: 'dashboard' }
            },
            {
              path: 'member',
              exact: true,
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/member'),
              name: '成员管理',
              meta: { title: '成员管理', icon: 'dashboard', activeMenu: '/sys/member' }
            },
            {
              path: 'member/:id/:org_id',
              exact: true,
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/member/Edit'),
              name: '成员编辑',
              meta: { title: '成员编辑', icon: 'dashboard', activeMenu: '/sys/member' }
            },
            {
              path: 'global',
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/global'),
              name: '全局设置',
              meta: { title: '全局设置', icon: 'dashboard' }
            },
            {
              path: 'message',
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/message'),
              name: '系统消息管理',
              meta: { title: '系统消息管理', icon: 'dashboard' }
            },
            {
              path: 'message/:id',
              component: () => import(/* webpackChunkName: "sys" */ '@/views/sys/message/detail'),
              name: '系统消息编辑',
              meta: { title: '系统消息编辑', icon: 'dashboard', activeMenu: '/sys/message' }
            }
          ]
        },
        {
          path: 'personal',
          component: Empty,
          name: '个人信息',
          children: [
            {
              path: 'base',
              component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/base'),
              name: '基础信息',
              meta: { title: '基础信息', icon: 'dashboard' }
            },
            {
              path: 'classes',
              component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/classes'),
              name: '我的班级',
              meta: { title: '我的班级', icon: 'dashboard', school: true }
            },
            {
              path: 'salary',
              component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/salary'),
              name: '我的工资单',
              meta: { title: '我的工资单', icon: 'dashboard' }
            },
            {
              path: 'teach',
              component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/teach'),
              name: '代课管理',
              meta: { title: '代课管理', icon: 'dashboard', school: true }
            },
            {
              path: 'message',
              component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/message'),
              name: '系统消息',
              meta: { title: '系统消息', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'user',
          component: Empty,
          name: '用户管理',
          children: [
            {
              path: 'registerUser',
              component: () => import(/* webpackChunkName: "user" */ '@/views/user/register'),
              name: '注册用户管理',
              meta: { title: '注册用户管理', icon: 'dashboard' }
            },
            {
              path: 'contact',
              component: () => import(/* webpackChunkName: "user" */ '@/views/user/contact'),
              name: '联系人管理',
              meta: { title: '联系人管理', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'entered',
          component: Empty,
          name: '报名管理',
          children: [
            {
              path: 'registrar',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/registrar'),
              name: '教务报名',
              meta: { title: '教务报名', icon: 'dashboard', school: true }
            },
            {
              path: 'team',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/team'),
              name: '集体报名',
              meta: { title: '集体报名', icon: 'dashboard', school: true }
            },
            {
              path: 'minister',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/minister'),
              name: '部长报名',
              meta: { title: '部长报名', icon: 'dashboard', school: true }
            },
            {
              path: 'student',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/student'),
              name: '报名学员管理',
              meta: { title: '报名学员管理', icon: 'dashboard', school: true }
            },
            {
              path: 'address',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/address'),
              name: '邮寄信息',
              meta: { title: '邮寄信息', icon: 'dashboard', school: true }
            },
            {
              path: 'guard',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/guard'),
              name: '门禁信息',
              meta: { title: '门禁信息', icon: 'dashboard', school: true }
            },
            {
              path: 'transfer',
              component: () => import(/* webpackChunkName: "entered" */ '@/views/entered/transfer'),
              name: '转班记录',
              meta: { title: '转班记录', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'message',
          component: Empty,
          name: '短信管理',
          children: [
            {
              path: 'manage',
              component: () => import(/* webpackChunkName: "message" */ '@/views/message/manage'),
              name: '模板管理',
              meta: { title: '模板管理', icon: 'dashboard' }
            },
            {
              path: 'group',
              component: () => import(/* webpackChunkName: "message" */ '@/views/message/group'),
              name: '短信组管理',
              meta: { title: '短信组管理', icon: 'dashboard' }
            },
            {
              path: 'send',
              component: () => import(/* webpackChunkName: "message" */ '@/views/message/send'),
              name: '短信发送',
              meta: { title: '短信发送', icon: 'dashboard' }
            },
            {
              path: 'record',
              component: () => import(/* webpackChunkName: "message" */ '@/views/message/record'),
              name: '发送记录',
              meta: { title: '发送记录', icon: 'dashboard' }
            },
            {
              path: 'count',
              component: () => import(/* webpackChunkName: "message" */ '@/views/message/count'),
              name: '短信统计',
              meta: { title: '短信统计', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'student',
          component: Empty,
          children: [
            {
              path: 'manage',
              component: () => import(/* webpackChunkName: "student" */ '@/views/student/manage'),
              name: '学员管理',
              meta: { title: '学员管理', icon: 'dashboard' }
            },
            {
              path: 'new',
              component: () => import(/* webpackChunkName: "student" */ '@/views/student/new'),
              name: '新学员查询',
              meta: { title: '新学员查询', icon: 'dashboard' }
            },
            {
              path: 'insurance',
              component: () => import(/* webpackChunkName: "student" */ '@/views/student/insurance'),
              name: '学员保险',
              meta: { title: '学员保险', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'salary',
          component: Empty,
          name: '薪酬管理',
          children: [
            {
              path: 'manage',
              component: () => import(/* webpackChunkName: "salary" */ '@/views/salary/manage'),
              name: '课酬管理',
              meta: { title: '课酬管理', icon: 'dashboard' }
            },
            {
              path: 'payroll',
              component: () => import(/* webpackChunkName: "salary" */ '@/views/salary/payroll'),
              name: 'payroll',
              meta: { title: '教师课酬计算', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'pay',
          component: Empty,
          name: '缴费管理',
          children: [
            {
              path: 'search',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/search'),
              name: '缴费查询',
              meta: { title: '缴费查询', icon: 'dashboard', school: true }
            },
            {
              path: 'discount',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/discount'),
              name: '打折清单',
              meta: { title: '打折清单', icon: 'dashboard' }
            },
            {
              path: 'count',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/count'),
              name: '报名收费统计',
              meta: { title: '报名收费统计', icon: 'dashboard' }
            },
            {
              path: 'supply',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/supply'),
              name: '补费查询',
              meta: { title: '补费查询', icon: 'dashboard', school: true }
            },
            {
              path: 'refund',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/refund'),
              name: '退费查询',
              meta: { title: '退费查询', icon: 'dashboard', school: true }
            },
            {
              path: 'quantity',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/quantity'),
              name: '批量退款',
              meta: { title: '批量退款', icon: 'dashboard', school: true }
            },
            {
              path: 'refundRequest',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/RefundRequest'),
              name: '退费申请单',
              meta: { title: '退费申请单', icon: 'dashboard', school: true }
            },
            {
              path: 'tips',
              component: () => import(/* webpackChunkName: "pay" */ '@/views/pay/tips'),
              name: '支付提示管理',
              meta: { title: '支付提示管理', icon: 'dashboard', school: true }
            }
          ]
        },
        {
          path: 'finance',
          component: Empty,
          name: '财务管理',
          children: [
            {
              path: 'order',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/order'),
              name: '订单管理',
              meta: { title: '订单管理', icon: 'dashboard' }
            },
            {
              path: 'refund',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/refund'),
              name: '退款管理',
              meta: { title: '退款管理', icon: 'dashboard' }
            },
            {
              path: 'income',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/income'),
              name: '收益统计',
              meta: { title: '收益统计', icon: 'dashboard' }
            },
            {
              path: 'verify',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/verify'),
              name: '财务对账',
              meta: { title: '财务对账', icon: 'dashboard' }
            },
            {
              path: 'count',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/count'),
              name: '财务统计',
              meta: { title: '财务统计', icon: 'dashboard' }
            },
            {
              path: 'invoice',
              component: () => import(/* webpackChunkName: "finance" */ '@/views/finance/invoice'),
              name: '发票管理',
              meta: { title: '发票管理', icon: 'dashboard', school: true }
            }
          ]
        },
        {
          path: 'news',
          component: Empty,
          name: '前台信息管理',
          children: [
            {
              path: 'briefed',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/briefed'),
              name: '资讯管理',
              meta: { title: '资讯管理', icon: 'dashboard' }
            },
            {
              path: 'briefed/:id',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/briefed/detail'),
              name: '资讯管理编辑',
              meta: { title: '资讯编辑', icon: 'dashboard', activeMenu: '/news/briefed' }
            },
            {
              path: 'web',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/web'),
              name: '站点信息管理',
              meta: { title: '站点信息管理', icon: 'dashboard' }
            },
            {
              path: 'web/:id',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/web/detail'),
              name: '站点信息编辑',
              meta: { title: '站点信息编辑', icon: 'dashboard', activeMenu: '/news/web' }
            },
            {
              path: 'idea',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/idea'),
              name: '意见收集',
              meta: { title: '意见收集', icon: 'dashboard' }
            },
            {
              path: 'problem',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/problem'),
              name: '常见问题',
              meta: { title: '常见问题', icon: 'dashboard' }
            },
            {
              path: 'contact',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/contact'),
              name: '联系信息',
              meta: { title: '联系信息', icon: 'dashboard' }
            },
            {
              path: 'richText',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/richText'),
              name: '说明信息',
              meta: { title: '说明信息', icon: 'dashboard' }
            },
            {
              path: 'cooperation',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/cooperation'),
              name: '合作信息',
              meta: { title: '合作信息', icon: 'dashboard' }
            },
            {
              path: 'announcement',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/announcement'),
              name: '系统公告',
              meta: { title: '系统公告', icon: 'dashboard' }
            },
            {
              path: 'ordinary_notice',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/infoNotice'),
              name: '信息通知',
              meta: { title: '信息通知', icon: 'notice' }
            },
            {
              path: 'notice',
              component: () => import(/* webpackChunkName: "news" */ '@/views/news/infoConfirm'),
              name: '信息确认',
              meta: { title: '信息确认', icon: 'notice' }
            }
          ]
        },
        {
          path: 'statistics',
          component: Empty,
          name: '数据统计',
          children: [
            {
              path: 'register',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/register'),
              name: '注册率统计',
              meta: { title: '注册率统计', icon: 'dashboard' }
            },
            {
              path: 'back',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/back'),
              name: '教师返读率统计',
              meta: { title: '教师返读率统计', icon: 'dashboard' }
            },
            {
              path: 'lottery',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/lottery'),
              name: '中签率统计',
              meta: { title: '中签率统计', icon: 'dashboard' }
            },
            {
              path: 'classRoom',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/classRoom'),
              name: '教室统计',
              meta: { title: '教室统计', icon: 'dashboard' }
            },
            {
              path: 'entered',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/entered'),
              name: '班级报名统计',
              meta: { title: '班级报名统计', icon: 'dashboard' }
            },
            {
              path: 'admission',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/admission'),
              name: '招生状况统计',
              meta: { title: '招生状况统计', icon: 'dashboard' }
            },
            {
              path: 'training',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/training'),
              name: '教师培训统计',
              meta: { title: '教师培训统计', icon: 'dashboard' }
            },
            {
              path: 'backStudy',
              component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/backStudy'),
              name: '项目返读率统计',
              meta: { title: '项目返读率统计', icon: 'dashboard' }
            }
          ]
        },
        {
          path: 'application',
          name: '应用管理',
          component: () => import(/* webpackChunkName: "application" */ '@/views/application'),
          meta: { title: '应用管理', icon: 'dashboard' }
        },
        {
          path: 'logger',
          component: () => import(/* webpackChunkName: "ticketIndex" */ '@/views/logger/index.vue'),
          name: '操作日志',
          meta: {
            title: '操作日志',
            icon: 'logger',
            affix: true
          }
        }
      ]
    },
    // 票务管理
    {
      path: '/:user_id/:sys_type',
      component: Layout,
      children: [
        {
          path: 'sector',
          component: () => import(/* webpackChunkName: "ticketIndex" */ '@/views/ticket/sector'),
          name: '首页',
          exact: true,
          meta: {
            title: '首页',
            icon: 'dashboard',
            affix: true
          }
        }
      ]
    },
    // 社区管理
    {
      path: '/:user_id/:sys_type',
      component: Layout,
      children: [
        {
          path: 'category',
          component: () => import(/* webpackChunkName: "category" */ '@/views/community/category'),
          name: '板块管理',
          meta: {
            title: '板块管理',
            icon: 'dashboard',
            affix: true
          }
        },
        {
          path: 'tipOffPost',
          component: () => import(/* webpackChunkName: "cpost" */ '@/views/community/posts'),
          name: '帖子举报',
          meta: {
            title: '帖子举报'
          }
        },
        {
          path: 'tipOffBack',
          component: () => import(/* webpackChunkName: "cpost" */ '@/views/community/posts/back'),
          name: '回帖举报',
          meta: {
            title: '回帖举报'
          }
        },
        {
          path: 'content',
          component: () => import(/* webpackChunkName: "cpost" */ '@/views/community/content'),
          name: '内容管理',
          meta: {
            title: '内容管理'
          }
        },
        {
          path: 'content/:id(\\d+)',
          component: () => import(/* webpackChunkName: "cpost" */ '@/views/community/content/detail'),
          name: '帖子详情',
          meta: {
            title: '帖子详情'
          }
        },
        {
          path: 'content/add/:id(-?\\d+)',
          component: () => import(/* webpackChunkName: "cpost" */ '@/views/community/content/add'),
          name: '发帖',
          meta: {
            title: '发帖'
          }
        },
        {
          path: 'user',
          component: () => import(/* webpackChunkName: "cuser" */ '@/views/community/user'),
          name: '社区用户',
          meta: {
            title: '社区用户'
          }
        },
        {
          path: 'setting',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/setting'),
          name: '系统设置',
          meta: {
            title: '系统设置'
          }
        },
        {
          path: 'newsType',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/news/type'),
          name: '类别管理',
          meta: {
            title: '类别管理'
          }
        },
        {
          path: 'newsContent/:id(-?\\d+)',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/news/content/edit'),
          name: '内容编辑',
          meta: {
            title: '内容编辑'
          }
        },
        {
          path: 'newsContent',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/news/content'),
          name: '内容管理',
          meta: {
            title: '内容管理'
          }
        },
        {
          path: 'newsContentDetail/:id(\\d+)',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/news/content/detail'),
          name: '内容详情',
          meta: {
            title: '内容详情'
          }
        },
        {
          path: 'newsSetting',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/news/setting'),
          name: '轮播管理',
          meta: {
            title: '轮播管理'
          }
        },
        {
          path: 'version',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/version'),
          name: '版本管理',
          meta: {
            title: '版本管理'
          }
        },
        {
          path: 'appointment',
          component: () => import(/* webpackChunkName: "category" */ '@/views/community/appointment'),
          name: '预约信息管理',
          meta: {
            title: '预约信息管理',
            icon: 'dashboard'
          }
        },
        {
          path: 'configuration',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/configuration'),
          name: '配置管理',
          meta: {
            title: '配置管理'
          }
        },
        {
          path: 'back',
          component: () => import(/* webpackChunkName: "csetting" */ '@/views/community/back'),
          name: '返回业务管理',
          meta: {
            title: '返回业务管理'
          }
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  if (window.$store.state.app.tempMenu.length === 0 && !to.meta.noLimit) {
    const flag = await window.$store.dispatch('app/getMenu');
    if (!flag) {
      next({ path: '/login' });
      NProgress.done();
      return;
    }
  }
  next();
  NProgress.done();
});

export default router;
